module.exports = __webpack_public_path__ + "assets/03cdc0328b8f0cb813946da1adb65c50.png";